import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import DspAssetsMgmt from './components/AssetsMgmt';

export default function DspAssetsPage() {
  return (
    <Container className="dashboard">
      <Row>
        <Col md={12}>
          <h3 className="page-title">Amazon Assets</h3>
        </Col>
      </Row>
      <Row>
        <DspAssetsMgmt />
      </Row>
    </Container>
  );
}
